module.exports = __webpack_public_path__ + "img/NA.4bfdd476.svg";